export const getPerfectStoreStepConfig = () => ({
  steps: 3,
  titles: [{title: 'Setup'}, {title: 'Display'}, {title: 'Review'}]
});
